import { SopGenerationPage } from '@/pages/sops/SopGenerationPage'
import PageLoading from '@/components/PageLoading'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/sops/$sopId/generate'
)({
  component: SopGenerationPage,
  pendingComponent: () => (
    <div className='w-screen'>
      <PageLoading />
    </div>
  ),
  pendingMs: 0,
  pendingMinMs: 200,
})
